import React from "react";
import { withTheme } from "styled-components";
import BookSwimlane from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import { t } from "../../../../core/translate";
import FetchingSpinner from "../../../../components/spinner/render-prop-spinner";

const PopularLane = ({
  popularTitleKey,
  popular,
  popularLoading,
  trendingCount,
  expandSwimlane
}) => {
  return (
    <FetchingSpinner
      loading={popularLoading}
      component={() => {
        return (
          <BookSwimlane
            isbns={popular.slice(trendingCount).map(asset => asset.vbid)}
            BookObject={BridgeBook}
            headerLabel={t(popularTitleKey, "Trending")}
            onHeaderClick={() =>
              expandSwimlane(popular, t(popularTitleKey, "Trending"))
            }
            count={Math.max(popular.length - trendingCount, 0)}
            backArrow={t("page.explorer", "Explore")}
          />
        );
      }}
    />
  );
};
export default withAllMatches(withTheme(PopularLane));
